export default {
  IOS: "ios",
  ANDROID: "android"
};
